<template>
  <m4-box v-bind="$attrs" :class="classes">
    <template v-slot:righttop v-if="hasRightTopSlot">
      <slot name="righttop"></slot>
    </template>
    <slot></slot>
    <template v-slot:footer v-if="hasFooterSlot">
      <slot name="footer"></slot>
    </template>
    <template v-slot:underfooter v-if="hasUnderFooterSlot">
      <slot name="underfooter"></slot>
    </template>
  </m4-box>
</template>

<script>
export default {
  name: "M4BoxWithOverlay",
  data() {
    return {
      visible: false
    };
  },
  props: {
    topBlur: Boolean
  },
  emits: ["open", "close"],
  computed: {
    classes() {
      let classes = ["box-with-overlay"];
      if (this.visible) {
        classes.push("box-with-overlay--visible");
      }
      if (this.topBlur) {
        classes.push("box-with-overlay--top-blur");
      }
      return classes;
    },
    hasBodySlot() {
      return typeof this.$slots.default === "function";
    },
    hasRightTopSlot() {
      return typeof this.$slots.righttop === "function";
    },
    hasFooterSlot() {
      return typeof this.$slots.footer === "function";
    },
    hasUnderFooterSlot() {
      return typeof this.$slots.underfooter === "function";
    }
  },
  methods: {
    open() {
      this.visible = true;
      this.$emit("open");
    },
    close() {
      this.visible = false;
      this.$emit("close");
    }
  }
};
</script>
